// webclient/src/pages/admin/RedirectToProduction.tsx
//
// Old /admin/production/groups/:id bookmarks (the retired model-console group
// page) land on the same production's page.
import { Navigate, useParams } from 'react-router';

const RedirectToProduction = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/admin/production/${id}` : '/admin/production'} replace />;
};

export default RedirectToProduction;
